/**
 * 可重试的网络/超时请求包装（联赛 API 等同款策略）。
 * @template T
 * @param {() => Promise<T>} task
 * @param {{ retries?: number, delayMs?: number }} [options]
 * @returns {Promise<T>}
 */
export async function withRetry(task, { retries = 2, delayMs = 800 } = {}) {
  let lastErr;
  for (let i = 0; i <= retries; i += 1) {
    try {
      return await task();
    } catch (err) {
      lastErr = err;
      if (!isRetryableRequestError(err) || i === retries) break;
      await new Promise((resolve) => setTimeout(resolve, delayMs * 2 ** i));
    }
  }
  throw lastErr;
}

/** @param {unknown} err */
export function isRetryableRequestError(err) {
  const message = String(err?.message ?? err?.code ?? '').toLowerCase();
  return (
    message.includes('timeout') ||
    message.includes('network') ||
    message.includes('econnaborted') ||
    message.includes('circuit breaker')
  );
}

/** @param {unknown} msgOrErr */
export function isRequestTimeoutLike(msgOrErr) {
  const message = String(msgOrErr?.message ?? msgOrErr ?? '').toLowerCase();
  return message.includes('timeout') || message.includes('econnaborted');
}
